<template>
  <div>
    <!--Has FUS: Add a FUS box -->
    <record-automated-follow-up-card
      v-if="activeSequenceId"
      :current-follow-up-id="activeSequenceId"
    ></record-automated-follow-up-card>

    <section-box>
      <record-info
        class="mb-100"
        :record="record"
        :status="status"
      ></record-info>

      <record-status-selector
        class="mb-100"
        :record="record"
      ></record-status-selector>

      <record-property-detail-summary
        class="mb-100"
        :property="record.property"
      ></record-property-detail-summary>

      <record-temperature-buttons
        class="mb-200"
        :record-id="record.id"
        v-model="record.temperature"
      ></record-temperature-buttons>

      <record-next-contact
        v-show="showNextContact"
        class="mb-200"
        :record="record"
        show-next-month
        hide-one-hour
      ></record-next-contact>

      <notes-with-latest :record="record"></notes-with-latest>
    </section-box>
  </div>
</template>

<script>
export default {
  name: "FollowUpLeadBox",
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeSequenceId() {
      if (this.record.active_sequence_id) return this.record.active_sequence_id

      if (this.record.contact && this.record.contact.active_sequence_id) return this.record.contact.active_sequence_id

      return null
    },
    status() {
      return this.$store.getters["pipeline/statuses"].find(status => status.id === this.record.current_status_id);
    },
    showNextContact() {
      return !this.record.active_sequence_id;
    },
  },
};
</script>
